//=====================================================
//　マイページヘッダー
//=====================================================
import { useContext, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom";
import { CtxAuth, CtxClinicInfo, CtxPatientInfo, CtxSystemErr, CtxNewReservation } from "../../utils/Contexts"
import { LoginStatusType, ReservationType } from "../../utils/ConstCommon"

export function PatientInfo(){

    const cserr = useContext(CtxSystemErr);
    const cpi = useContext(CtxPatientInfo);
    const cci = useContext(CtxClinicInfo);
    const cua = useContext(CtxAuth);
    const cnr = useContext(CtxNewReservation);
    const location = useLocation();
    const history = useHistory();

    //患者情報の再取得
    useEffect(function(){
        if( cua.isLoggedIn() && !cpi.data.patientId ){
            //患者情報再取得
            let errMess = cpi.getData(cci.data.id, cua.getPatientNo() );
            if(errMess){
                cserr.setErrmess(errMess);
            }
        }
        if( cnr.type !== ReservationType.First && cua.checkExpiresIn() === LoginStatusType.LoginExpired ){
            //ログイン期限切れならTOPへ
            cua.logout(function(){history.push("/")});
        }
        // エラーメッセージを更新するため、cserrは第2引数から除外する
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[cua, location.pathname]
    );

    //ログアウト処理
    function clickLogout(){
        cua.logout(function(){history.push("/")});
    }
    
    if (cua.isLoggedIn() && location.pathname !== "/"){
        //ログイン時かつトップページ以外の場合に表示する
        return (
            <div className="patient-info">
                <div className="patient-info-content">
                    <ul>
                    <li className="patient-info-number-name"><span className="patient-info-number-name-text">{cpi.data.patientId}：{cpi.data.lastName} {cpi.data.firstName} 様</span></li>
                    <li className="patient-info-last-visit"><span className="patient-info-last-visit-text">前回のご来院日時：{cpi.data.lastVisitDate}</span></li>
                    </ul>
                    <button className="btn btn-logout" onClick={clickLogout}>ログアウト</button>
                </div>
            </div>
        )
    } else {
        return null;
    }

}